import { Receipt } from "lucide-react"

import { SectionSidebarLayout } from "./SectionSidebarLayout"

export function OrdersSectionLayout() {
  return (
    <SectionSidebarLayout
      navId="orders"
      navItems={[{ icon: Receipt, label: "All orders", to: "/orders" }]}
    />
  )
}
